/**
 * Registration data of each child component
 */
export interface IComponentRegistrationData {
  /**
   * Time when the component starts rendering
   */
  startTime: number;
}

export interface IComponent {
  componentName: string;
}

/**
 * The type that contains tracked data of the registered component
 */
export interface IRegisteredComponentData {
  /**
   * Name of the required component
   */
  readonly name: string;
  /**
   * Action to take to change QoS state
   */
  readonly state: QosState;
  /**
   * Time when the required component starts loading
   */
  readonly startTime: number;
  /**
   * Time when the required component reports to QoSProvider
   */
  readonly endTime: number;
  /**
   * Additional data, such as error object
   */
  readonly data?: unknown;
}

/**
 * Enum for the actions values that change the Qos status
 */
export enum QosState {
  IDLE = 'idle',
  /**
   * Dispatched when the UI wrapped by the QosProvider finishes loading without failures
   */
  LOAD_COMPLETE = 'loadComplete',
  /**
   * Dispatched when the UI wrapped by the QosProvider failed to load
   */
  LOAD_FAILURE = 'loadFailure',
  /**
   * Dispatched when the UI wrapped by the QosProvider failed to load after a LOAD_COMPLETE action was dispatched.
   */
  UPDATE_FAILURE = 'updateFailure',
  /**
   * Dispatched when the UI wrapped by the QosProvider is timed out
   */
  TIMEOUT = 'timeout'
}
